import React from "react";
import { Box, Card, CardContent, Typography, Button } from "@mui/material";

interface MastercardProps {
  title: string;
  description: string;
  image: string;
  primaryColor: string;
  stat1: string;
  stat2: string;
  stat1Color?: string;
  stat2Color?: string;
  buttonText: string;
  onClick: () => void;
}

const Mastercard: React.FC<MastercardProps> = ({
  title,
  description,
  image,
  primaryColor,
  stat1,
  stat2,
  stat1Color = "green",
  stat2Color = "red",
  buttonText,
  onClick,
}) => {
  return (
    <Card
    onClick={onClick}
      sx={{
        height: "auto",
        padding: 1,
        boxShadow: "0px 0px 50px 1px rgba(0, 0, 0, 0.1)",
        borderRadius: 3,
        
      }}
    >
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <Box
            sx={{
              width: 4,
              height: 26,
              bgcolor: primaryColor,
              borderRadius: 1,
              mr: 1.5,
            }}
          />
          <Typography variant="h6" gutterBottom sx={{ color: primaryColor }}>
            {title}
          </Typography>
        </Box>

        <img
          src={image}
          alt={`${title} illustration`}
          style={{ width: "100%", height: "auto", marginRight: 10 }}
        />

        <Typography
          variant="subtitle2"
          color="#4f4f4f"
          sx={{ mb: 6, mt: 3 }}
        >
          {description}
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box>
            <Typography
              variant="body2"
              color="#7d7d7d"
              sx={{ display: "flex", alignItems: "center", mb: 1 }}
            >
              <Box
                component="span"
                sx={{
                  width: 6,
                  height: 6,
                  bgcolor: stat1Color,
                  borderRadius: "50%",
                  display: "inline-block",
                  mr: 1,
                }}
              />
              {stat1}
            </Typography>
            <Typography variant="body2" color="#7d7d7d">
              <Box
                component="span"
                sx={{
                  width: 6,
                  height: 6,
                  bgcolor: stat2Color,
                  borderRadius: "50%",
                  display: "inline-block",
                  mr: 1,
                }}
              />
              {stat2}
            </Typography>
          </Box>

          <Button color="primary"  size="small">
            {buttonText}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default Mastercard;
